<template functional>
  <h6 :class="$options.modifiedClasses('card__title', props.modifiers)">
    <slot />
  </h6>
</template>

<script>
export default {
  props: {
    modifiers: { type: Array, default: () => [] }
  },
  modifiedClasses(mainClass, modifiers) {
    const modifiedClasses = modifiers.map(
      modifier => `${mainClass}--${modifier}`
    )
    return [mainClass, ...modifiedClasses]
  }
}
</script>
